import { Button } from "@/components/tiptapNovel/ui/button";
import { Divider } from "antd";
import { RedoIcon, UndoIcon } from "lucide-react";
import { useEditor } from "novel";

export const FloatingStatusToolbar = () => {
  const { editor } = useEditor();

  if (!editor) return null;

  const { from, to, empty } = editor.state.selection;
  const selected = empty ? "" : editor.state.doc.textBetween(from, to, "\n");
  const chars = selected.replace(/\s/g, "").length;
  const canUndo = editor.can().undo();
  const canRedo = editor.can().redo();

  return (
    <div className="px-0.5 py-0.5 rounded-md flex empty:hidden pointer-events-auto nc-editor-action-bubble border border-[var(--tt-line,rgba(60,50,40,0.12))] bg-[var(--tt-surface,#faf9f6)] text-[var(--tt-ink,#2c2a26)] shadow-sm">
      <div className="rounded self-center px-2.5 py-1 text-xs whitespace-nowrap text-[var(--tt-muted,#5c5854)]">
        <span
          className="whitespace-nowrap tracking-wide"
          style={{
            fontFamily: "var(--tt-sans, PingFang SC, system-ui, sans-serif)",
            fontVariantNumeric: "tabular-nums lining-nums",
            fontFeatureSettings: '"tnum" 1, "lnum" 1',
            fontWeight: 500,
          }}
        >
          {chars}
          <span className="ml-0.5 font-normal opacity-80">字</span>
        </span>
      </div>
      <Divider type="vertical" className="mx-0.5 h-full top-0 bg-[var(--tt-line,rgba(60,50,40,0.18))]" />
      <div className="flex gap-0.5 empty:hidden">
        <Button
          size="sm"
          variant="ghost"
          disabled={!canUndo}
          title="撤销"
          onClick={() => editor.chain().focus().undo().run()}
        >
          <UndoIcon className="size-4" strokeWidth={2.3} />
        </Button>
        <Button
          size="sm"
          variant="ghost"
          disabled={!canRedo}
          title="重做"
          onClick={() => editor.chain().focus().redo().run()}
        >
          <RedoIcon className="size-4" strokeWidth={2.3} />
        </Button>
      </div>
    </div>
  );
};
